import React, { FC } from 'react';
import CancelPrepaidOrderModal from './cancel-prepaid-order-modal';
import CancelPostpaidOrderModal from './cancel-postpaid-order-modal';
import { OrderType } from 'models/order.model';
import { getOrderStatus } from 'utils/functions';
import { ENUM_STATUS } from 'utils/enum';

type CancelOrderModalProps = {
  show: boolean;
  onClose: () => void;
  order: OrderType;
};

const CancelOrderModal: FC<CancelOrderModalProps> = ({ show, onClose, order }) => {
  const isUnpaid = getOrderStatus(order) === ENUM_STATUS.UNPAID;

  return isUnpaid ? (
    <CancelPrepaidOrderModal show={show} onClose={onClose} order={order} />
  ) : (
    <CancelPostpaidOrderModal show={show} onClose={onClose} order={order} />
  );
};

export default CancelOrderModal;
